import { useMemo } from "react"
import { LOCKED_MARKET_KEYS } from "src/services/api/commitments"
import { useConfirmedRankingStore } from "src/store/confirmedRankingStore"

const RANKING_COLUMNS_BY_ASSET: Record<
    string,
    Array<{ original: string; traduzido: string }>
> = {
    FUNDOS: [
        { original: "rateOfReturn", traduzido: "taxa de retorno" },
    ],
    PREVIDENCIA: [{ original: "rateOfReturn", traduzido: "taxa de retorno" }],
    "RENDA FIXA": [
        { original: "dateDue", traduzido: "data de vencimento" },
        { original: "rateOfReturn", traduzido: "taxa de retorno" },
    ],
    "RENDA VARIAVEL": [
        { original: "cnpj", traduzido: "cnpj" },
        { original: "nameProduct", traduzido: "nome do produto" },
        { original: "rateOfReturn", traduzido: "taxa de retorno" },
    ],
}

const ASSET_DISPLAY_NAMES: Record<string, { label: string; description: string }> = {
    FUNDOS: {
        label: "Fundos de Investimento",
        description: "FICs e FIIs com maior exposição a liquidez nos próximos 30 dias.",
    },
    PREVIDENCIA: {
        label: "Previdência",
        description: "Fundos de previdência",
    },
    "RENDA FIXA": {
        label: "Renda Fixa",
        description: "CDB, LCI, LCA e debêntures com maior volume em vencimento no período.",
    },
    "RENDA VARIAVEL": {
        label: "Renda Variável",
        description: "Ações e ETFs com maior volume de aportes programados.",
    },
}

/** Markets that appear in ranking UI (order preserved for display). */
export const RANKING_MARKET_KEYS_ORDER = Object.keys(RANKING_COLUMNS_BY_ASSET) as string[]

export const getMarketRankingDisplayName = (marketKey: string): string =>
    ASSET_DISPLAY_NAMES[marketKey]?.label ?? marketKey

export const useRankingAssets = () => {
    const confirmedRankingByMarket = useConfirmedRankingStore((s) => s.confirmedRankingByMarket)

    const rankingAssets = useMemo(() => {
        return (
            Object.keys(RANKING_COLUMNS_BY_ASSET) as Array<keyof typeof RANKING_COLUMNS_BY_ASSET>
        ).map((key) => {
            const columns = RANKING_COLUMNS_BY_ASSET[key]
            const rankings = columns.reduce<Record<string, string>>(
                (acc, { original, traduzido }) => ({ ...acc, [original]: traduzido }),
                {}
            )
            const base = ASSET_DISPLAY_NAMES[key] ?? { label: key, description: "" }
            const confirmed = confirmedRankingByMarket[key]
            const description = confirmed?.ranking_text ?? base.description
            const label = base.label
            const locked = LOCKED_MARKET_KEYS.has(key)
            return {
                assetKey: key,
                asset: label,
                date: "Jan 2026",
                description,
                rankings,
                locked,
            }
        })
    }, [confirmedRankingByMarket])

    return { rankingAssets }
}
